<div class="heading logo" padding>
  <img *ngIf="!logoUrl" alt="logo" src="/src/assets/images/Group.png" />
  <img *ngIf="logoUrl" alt="logo" [src]="logoUrl" class="logo-img" />
</div>
